module.exports = __webpack_public_path__ + "static/media/Kristel Valaydon.092f37ee.png";